export default "__VITE_ASSET__$J2gHE0yBJs0Ivd69ncEuA__";